import { render, staticRenderFns } from "./indexC.vue?vue&type=template&id=28494a28&scoped=true&"
import script from "./indexC.vue?vue&type=script&lang=js&"
export * from "./indexC.vue?vue&type=script&lang=js&"
import style0 from "./indexC.vue?vue&type=style&index=0&id=28494a28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28494a28",
  null
  
)

export default component.exports